module.exports = __webpack_public_path__ + "static/media/sc5.4ff74133.png";